import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f3e52c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth reset-password" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = { class: "form-group row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1))
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = {
  key: 2,
  class: "form-group row"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Code", -1))
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = {
  key: 3,
  class: "form-group row"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "New Password", -1))
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  id: "passwordHelp",
  class: "form-text text-muted"
}, " Min. 8 chars with at least 1 uppercase letter, lowercase letter and digit. ", -1))
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = { class: "col-sm-6 offset-sm-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted ml-4" }, "or", -1))

import { ref, inject } from 'vue';
import { useRouter } from 'vue-router';
import Auth from '@aws-amplify/auth';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const router = useRouter();
const toasted = useToast();

const actProperty: any = inject('actProperty');

// Reactive state for form data and control flow
const step = ref(1);
const error = ref('');
const sentTo = ref('');
const username = ref('');
const code = ref('');
const newPassword = ref('');

// Methods for each step in the reset password flow
const step1 = async () => {
  error.value = '';
  sentTo.value = '';
    Auth.forgotPassword(username.value)
      .then((data: any) => {
        sentTo.value = data.CodeDeliveryDetails.Destination;
        step.value = 2;
      })
      .catch((err: any) => actProperty.displayError(err));
};

const step2 = async () => {
  Auth.forgotPasswordSubmit(username.value, code.value, newPassword.value)
    .then((data: any) => {
      step.value = 1;
      username.value = '';
      code.value = '';
      newPassword.value = '';
      toasted.success('Password reset');
      signIn();
    })
    .catch((err: any) => actProperty.displayError(err));
};

// Helper method for navigation
const signIn = () => {
  router.push({ name: 'sign-in' });
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (sentTo.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Check " + _toDisplayString(sentTo.value) + " for your reset code. ", 1))
      : _createCommentVNode("", true),
    (error.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
        }, null, 512), [
          [
            _vModelText,
            username.value,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    (step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event))
            }, null, 512), [
              [
                _vModelText,
                code.value,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event))
            }, null, 512), [
              [_vModelText, newPassword.value]
            ]),
            _hoisted_13
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (step.value == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (step1())),
              disabled: !username.value.length
            }, " Send reset code ", 8, _hoisted_16))
          : _createCommentVNode("", true),
        (step.value == 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (step2())),
              disabled: !username.value.length
            }, " Set password ", 8, _hoisted_17))
          : _createCommentVNode("", true),
        _hoisted_18,
        _createElementVNode("button", {
          class: "btn btn-link ml-3",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (signIn()))
        }, " Sign in ")
      ])
    ])
  ]))
}
}

})